import { useLazyQuery } from "@apollo/client/react";
import { MenuItem } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { SwitchInput } from '../../../components/switchInput/SwitchInput';
import { ButtonOptionGroup } from '../../../components/buttonOptionGroup/ButtonOptionGroup';
import { Chip, FormControl, Grid, InputAdornment, InputLabel, Select, Stack, TextField } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { useForm } from '../../../components/hooks/useForm';
import { GET_PRODUCTOS_SAP } from '../../../data/graphQL/queries/Insumos/queries';
import './tabDatosGenerales.scss';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';

export default function TabDatosGenerales({ insumo, setInsumo, unidades, fabricantes, tipoInsumos, franjaEtarias, setListaTM, setListaProductosCaja, setListaAccesos, listaInsumos, edit }) {

  let { Id, IdInsumo, EsSAP, IdUnidad, Descripcion, IdFabricante, IdTipoInsumo, DescripcionGenerica, PresentacionGenerica, Activo, PresentacionComercial,
    IdFranjaEtarea, CantidadPack, Peso, CantidadDias, Validado, MotivoValidacion, Fraccionable, UnidadVenta, Calorias, Proteinas } = insumo;

  const [selectedSAPFilter, setSelectedSAPFilter] = useState(insumo.EsSAP ? 1 : 0);

  const [selectedFranjaEtariaFilter, setSelectedFranjaEtariaFilter] = useState(insumo.IdFranjaEtarea);

  const [selectedUnidadFilter, setSelectedUnidadFilter] = useState(insumo.IdUnidad);

  const handleSAPClick = (e) => {
    setSelectedSAPFilter(e);

    setOpenDlgSAP(Boolean(e));

    setFormValues(
      {
        ...formValues,
        EsSAP: Boolean(e)
      });

    if (!Boolean(e)) {
      setFormValues({
        ...formValues,
        EsSAP: Boolean(e),
        IdInsumo: '',
        Descripcion: '',
        DescripcionGenerica: ''
      });
    } else
    {
      getProductoSAP();
    }
  };

  const handleToggle = (e) => {
    const { checked, name } = e.target;

    if (name == 'activo') {
      setFormValues(
        {
          ...formValues,
          Activo: checked
        });
      setInsumo((prevState) => {
        return {
          ...prevState,
          datosGenerales: {
            ...formValues,
            Activo: checked
          }
        };
      });
    } else
    {
      setFormValues(
        {
          ...formValues,
          Fraccionable: checked
        });
      setInsumo((prevState) => {
        return {
          ...prevState,
          datosGenerales: {
            ...formValues,
            Fraccionable: checked
          }
        };
      });
    }
  };

  const handleFranjaEtariaClick = (e) => {
    let value = e;
    setSelectedFranjaEtariaFilter(e);

    setFormValues(
      {
        ...formValues,
        IdFranjaEtarea: value
      });

    setInsumo((prevState) => {
      return {
        ...prevState,
        datosGenerales: {
          ...formValues,
          IdFranjaEtarea: value
        }
      };
    });
  };

  const handleUnidadClick = (e) => {
    let value = e;
    setSelectedUnidadFilter(e);

    setFormValues(
      {
        ...formValues,
        IdUnidad: value
      });

    setInsumo((prevState) => {
      return {
        ...prevState,
        datosGenerales: {
          ...formValues,
          IdUnidad: value
        }
      };
    });
  };

  const [formValues, formHandle, reset, setFormValues] = useForm({
    IdInsumo: IdInsumo,
    EsSAP: EsSAP,
    IdUnidad: IdUnidad,
    Descripcion: Descripcion,
    IdFabricante: IdFabricante,
    IdTipoInsumo: IdTipoInsumo,
    DescripcionGenerica: DescripcionGenerica,
    PresentacionGenerica: PresentacionGenerica,
    Activo: Activo,
    PresentacionComercial: PresentacionComercial,
    IdFranjaEtarea: IdFranjaEtarea,
    CantidadPack: CantidadPack,
    Peso: Peso,
    CantidadDias: CantidadDias,
    Validado: Validado,
    MotivoValidacion: MotivoValidacion,
    UnidadVenta: UnidadVenta,
    Fraccionable: Fraccionable,
    Calorias: Calorias,
    Proteinas: Proteinas
  });

  // dlg de error
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  const [openDlgSAP, setOpenDlgSAP] = useState(false);
  const txtFiltro = useRef(null);
  const [productosSAP, setProductosSAP] = useState([]);
  const [productosSAPOriginal, setProductosSAPOriginal] = useState([]);

  const [getProductoSAP, { error: errorProductoSAP, data: dataProductoSAP }] = useLazyQuery(GET_PRODUCTOS_SAP, {
    fetchPolicy: 'no-cache'
  });

	useEffect(() => {
		if (!dataProductoSAP) return;
		if (dataProductoSAP.productosSAP.success) {
      const dataAll = dataProductoSAP.productosSAP.valorEsperado;

      setProductosSAP(dataAll);
      setProductosSAPOriginal(dataAll);
    };
	}, [dataProductoSAP]);

  useEffect(() => {
    if (!errorProductoSAP) return;
    setMensajeError("ERRORDB");
  }, [errorProductoSAP]);  

  // handles
  const handleChangeEsSAP = (event) => {
    setOpenDlgSAP(event.target.checked);

    setFormValues(
      {
        ...formValues,
        EsSAP: event.target.checked
      });

    if (!event.target.checked) {
      setFormValues({
        ...formValues,
        EsSAP: false,
        IdInsumo: '',
        Descripcion: '',
        DescripcionGenerica: ''
      });
    } else
    {
      getProductoSAP();
    }
  };

  // handles de Dialog Instituciones SAP
  const handleSearch = () => {
    // si se ingresó texto a buscar (al menos 3 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (productosSAPOriginal.length > 0) {
      if (txtFiltro.current.value != "") {
        setProductosSAP(productosSAPOriginal.filter((productosSAPOriginal) => {
          const codigoBuscar = productosSAPOriginal.cod_articulo.toLowerCase();
          const descripcionBuscar = productosSAPOriginal.descripcion.toLowerCase();

          const inputBuscar = txtFiltro.current.value.toLowerCase();
          return (
            codigoBuscar.includes(inputBuscar) ||
            descripcionBuscar.includes(inputBuscar));

        }
        ));
      } else {
        setProductosSAP(productosSAPOriginal);
      }
    }
  };

  const handleClean = () => {
    txtFiltro.current.value = "";
    handleSearch();
    txtFiltro.current.focus();
  };

  const handleRowClick = (params) => {

    setFormValues(
      {
        ...formValues,
        IdInsumo: params.row.cod_articulo,
        Descripcion: params.row.descripcion,
        DescripcionGenerica: params.row.descripcion
      });


    setOpenDlgSAP(false);
    LimpiarDlgSAP();
  };

  const handleCloseDlgSAP = () => {
    setOpenDlgSAP(false);
    LimpiarDlgSAP();

    setFormValues({
      ...formValues,
      EsSAP: !formValues.EsSAP
    });

    setSelectedSAPFilter(0);
  };

  const LimpiarDlgSAP = () => {
    txtFiltro.current.value = "";
    setProductosSAP(productosSAPOriginal);
  };

  // COLUMAS DE GRILLAS
  const initialColumns = [
  {
    field: 'cod_articulo',
    headerName: 'Codigo'
  },
  {
    field: 'descripcion',
    headerName: 'Descripcion'
  }];


  const columns = generateColumnsDefaultConfiguration(initialColumns);

  return (
    <>
            <div className='insumos-tab-datosGenerales'>
                <div className='insumos-tab-datosGenerales-linea' style={{ marginTop: '0px' }}>
                    <Grid
            container
            direction="row"
            justifyContent="space-between"
            spacing={2}
            flex={1}>
            
                        <Grid size={{ md: 2 }}>
                            <div className='insumos-tab-datosGenerales-linea-control'>
                                <span className='span-row'>Origen</span>
                                <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                                    <ButtonOptionGroup
                    options={['NSAP', 'SAP']}
                    onOptionClick={!edit ? handleSAPClick : () => {}}
                    selectedOption={selectedSAPFilter}
                    disabled={edit} />
                  
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid size={{ md: 4.5 }}>
                            <div className='insumos-tab-datosGenerales-linea-control'>
                                <TextField
                  sx={{ background: 'white', width: '100%' }}
                  label="IdInsumo"
                  name="IdInsumo"
                  onChange={formHandle}
                  onBlur={(e) => {
                    let item = listaInsumos?.find((x) => x.idInsumo.trim() == formValues.IdInsumo.trim());
                    if (!item) {
                      setInsumo((prevState) => {
                        return {
                          ...prevState,
                          datosGenerales: {
                            ...formValues,
                            IdInsumo: e.target.value
                          }
                        };
                      });
                    } else
                    {
                      toast.error('El cógido de insumo ingresado ya existe');
                      setFormValues(
                        {
                          ...formValues,
                          IdInsumo: ''
                        });
                    }
                  }}
                  size="small"
                  type="text"
                  value={formValues.IdInsumo}
                  variant="outlined"
                  disabled={formValues.EsSAP} />
                
                            </div>
                        </Grid>
                        <Grid size={{ md: 3 }}>
                            <div className='insumos-tab-datosGenerales-linea-control'>
                                <span className='span-row'>Franja Etaria</span>
                                <FormControl sx={{ backgroundColor: 'white' }} size="small">
                                    <ButtonOptionGroup
                    options={['Pediatrico', 'Adulto', 'Ambos']}
                    onOptionClick={handleFranjaEtariaClick}
                    selectedOption={selectedFranjaEtariaFilter} />
                  
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid size={{ md: 1.2 }}>
                            <div className='insumos-tab-datosGenerales-linea-control'>
                                <span className='span-row'>Activo</span>
                                    <SwitchInput
                  onChange={handleToggle}
                  name='activo'
                  checked={formValues.Activo} />
                
                            </div>
                        </Grid>
                        <Grid size={{ md: 1.3 }}>
                            <div className='insumos-tab-datosGenerales-linea-control'>
                                <span className='span-row'>Validado</span>
                                    <Chip className='chip-preview' label={formValues.Validado ? "SI" : "NO"} />
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <div className='insumos-tab-datosGenerales-linea'>
                    <Grid
            container
            direction="row"
            justifyContent="space-between"
            spacing={2}
            flex={1}>
            
                        <Grid size={{ md: 4 }}>
                            <div className='insumos-tab-datosGenerales-linea-control'>
                                <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                                    <InputLabel id="select-fabricante">Fabricante</InputLabel>
                                    <Select
                    labelId="select-fabricante"
                    id="Fabricante"
                    value={formValues.IdFabricante}
                    label="Fabricante"
                    onChange={(e) =>
                    setFormValues(
                      {
                        ...formValues,
                        IdFabricante: e.target.value
                      })
                    }
                    onBlur={(e) => {
                      setInsumo((prevState) => {
                        return {
                          ...prevState,
                          datosGenerales: {
                            ...formValues,
                            IdFabricante: e.target.value
                          }
                        };
                      });
                    }}>
                    
                                        {fabricantes && fabricantes.map((fabricante) => {
                      return <MenuItem value={fabricante.idLaboFabri}> {fabricante.descripcion} </MenuItem>;
                    })}
                                    </Select>
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid size={{ md: 4 }}>
                            <div className='insumos-tab-datosGenerales-linea-control'>
                                <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                                    <InputLabel id="select-tipoInsumo">Tipo Insumo</InputLabel>
                                    <Select
                    labelId="select-tipoInsumo"
                    id="TipoInsumo"
                    value={formValues.IdTipoInsumo}
                    label="TipoInsumo"
                    onChange={(e) => {
                      setFormValues(
                        {
                          ...formValues,
                          IdTipoInsumo: e.target.value,
                          Calorias: '',
                          Proteinas: ''
                        });
                    }
                    }
                    onBlur={(e) => {
                      setInsumo((prevState) => {
                        return {
                          ...prevState,
                          datosGenerales: {
                            ...formValues,
                            IdTipoInsumo: e.target.value
                          }
                        };
                      });

                      if (e.target.value != 1) {
                        setInsumo((prevState) => {
                          return {
                            ...prevState,
                            datosCategorizacion: {
                              ...formValues,
                              IdCategoria: 0
                            }
                          };
                        });
                      }

                      if (e.target.value != 2) {
                        setListaAccesos([]);
                        setListaTM([]);
                        setListaProductosCaja([]);
                      }
                    }}
                    //disabled={edit && formValues.IdTipoInsumo > 0}
                  >
                                        {tipoInsumos && tipoInsumos.map((tipoInsumo) => {
                      return <MenuItem value={tipoInsumo.idTipoInsumo}> {tipoInsumo.descripcion} </MenuItem>;
                    })}
                                    </Select>
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid size={{ md: 4 }}>
                            <div className='insumos-tab-datosGenerales-linea-control'>
                                <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                                    <TextField
                    label="Cantidad de dias"
                    name="CantidadDias"
                    onChange={formHandle}
                    onBlur={(e) =>
                    setInsumo((prevState) => {
                      return {
                        ...prevState,
                        datosGenerales: {
                          ...formValues,
                          CantidadDias: e.target.value
                        }
                      };
                    })
                    }
                    size="small"
                    type="number"
                    InputProps={{ inputProps: { min: 0 } }}
                    value={formValues.CantidadDias}
                    variant="outlined"
                    disabled={formValues.IdTipoInsumo != 2} />
                  

                                </FormControl>
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <div className='insumos-tab-datosGenerales-linea'>
                    <Grid
            container
            direction="row"
            justifyContent="space-between"
            spacing={2}
            flex={1}>
            
                        <Grid size={{ md: 12 }}>
                            <div className='insumos-tab-datosGenerales-linea-control'>
                                <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                                    <TextField
                    label="Descripcion"
                    name="Descripcion"
                    onChange={formHandle}
                    onBlur={(e) =>
                    setInsumo((prevState) => {
                      return {
                        ...prevState,
                        datosGenerales: {
                          ...formValues,
                          Descripcion: e.target.value
                        }
                      };
                    })
                    }
                    size="small"
                    type="text"
                    value={formValues.Descripcion}
                    variant="outlined" />
                  
                                </FormControl>
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <div className='insumos-tab-datosGenerales-linea'>
                    <Grid
            container
            direction="row"
            justifyContent="space-between"
            spacing={2}
            flex={1}>
            
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6 }}>
                            <TextField
                sx={{ backgroundColor: 'white', width: '100%' }}
                label="Descripcion Generica"
                name="DescripcionGenerica"
                onChange={formHandle}
                onBlur={(e) =>
                setInsumo((prevState) => {
                  return {
                    ...prevState,
                    datosGenerales: {
                      ...formValues,
                      DescripcionGenerica: e.target.value
                    }
                  };
                })
                }
                size="small"
                type="text"
                value={formValues.DescripcionGenerica}
                variant="outlined" />
              
                        </Grid>
                        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6 }}>
                            <TextField
                sx={{ backgroundColor: 'white', width: '100%' }}
                label="Presentacion Generica"
                name="PresentacionGenerica"
                onChange={formHandle}
                onBlur={(e) =>
                setInsumo((prevState) => {
                  return {
                    ...prevState,
                    datosGenerales: {
                      ...formValues,
                      PresentacionGenerica: e.target.value
                    }
                  };
                })
                }
                size="small"
                type="text"
                value={formValues.PresentacionGenerica}
                variant="outlined" />
              
                        </Grid>
                    </Grid>
                </div>
                <div className='insumos-tab-datosGenerales-linea'>
                    <Grid
            container
            direction="row"
            justifyContent="space-between"
            spacing={2}
            flex={1}>
            
                        <Grid size={{ xs: 4, sm: 4, md: 4, lg: 1.8 }}>
                            <TextField
                sx={{ background: 'white', width: '100%' }}
                label="Presentacion Comercial"
                name="PresentacionComercial"
                onChange={(e) => {
                  const valor = e.target.value;
                  if (valor >= 0) {
                    setFormValues(
                      {
                        ...formValues,
                        PresentacionComercial: valor
                      });
                  }
                }
                }
                onBlur={(e) =>
                setInsumo((prevState) => {
                  return {
                    ...prevState,
                    datosGenerales: {
                      ...formValues,
                      PresentacionComercial: e.target.value
                    }
                  };
                })
                }
                size="small"
                type="number"
                InputProps={{ inputProps: { min: 0 } }}
                value={formValues.PresentacionComercial}
                variant="outlined" />
              
                        </Grid>
                        <Grid size={{ xs: 4, sm: 4, md: 4, lg: 2.5 }}>
                            <div className='insumos-tab-datosGenerales-linea-control'>
                                <span className='span-row'>Unidad</span>
                                <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                                    <ButtonOptionGroup
                    options={['gr', 'ml', 'unidad', 'mg']}
                    onOptionClick={handleUnidadClick}
                    selectedOption={selectedUnidadFilter} />
                  
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid size={{ xs: 4, sm: 4, md: 4, lg: 2 }}>
                            <div className='insumos-tab-datosGenerales-linea-control'>
                                <TextField
                  className="input-300"
                  label="Unidad de venta"
                  name="UnidadVenta"
                  onChange={(e) => {
                    const valor = e.target.value;
                    if (valor >= 0) {
                      setFormValues(
                        {
                          ...formValues,
                          UnidadVenta: valor
                        });
                    }
                  }
                  }
                  onBlur={(e) =>
                  setInsumo((prevState) => {
                    return {
                      ...prevState,
                      datosGenerales: {
                        ...formValues,
                        UnidadVenta: e.target.value
                      }
                    };
                  })
                  }
                  size="small"
                  type="number"
                  InputProps={{ inputProps: { min: 0 } }}
                  value={formValues.UnidadVenta}
                  variant="outlined" />
                
                            </div>
                        </Grid>
                        <Grid size={{ xs: 4, sm: 4, md: 4, lg: 1.8 }}>
                            <div className='insumos-tab-datosGenerales-linea-control'>
                                <TextField
                  className="input-300"
                  label="Peso unitario(kg)"
                  name="Peso"
                  onChange={(e) => {
                    const valor = e.target.value;
                    if (valor >= 0) {
                      setFormValues(
                        {
                          ...formValues,
                          Peso: valor
                        });
                    }
                  }
                  }
                  onBlur={(e) =>
                  setInsumo((prevState) => {
                    return {
                      ...prevState,
                      datosGenerales: {
                        ...formValues,
                        Peso: e.target.value
                      }
                    };
                  })
                  }
                  size="small"
                  type="number"
                  InputProps={{ inputProps: { min: 0 } }}
                  value={formValues.Peso}
                  variant="outlined" />
                
                            </div>
                        </Grid>
                        <Grid size={{ xs: 4, sm: 4, md: 4, lg: 1.7 }}>
                            <div className='insumos-tab-datosGenerales-linea-control'>
                                <TextField
                  className="input-300"
                  label="Cantidad pack cerrado"
                  name="CantidadPack"
                  onChange={(e) => {
                    const valor = e.target.value;
                    if (valor >= 0) {
                      setFormValues(
                        {
                          ...formValues,
                          CantidadPack: valor
                        });
                    }
                  }
                  }
                  onBlur={(e) =>
                  setInsumo((prevState) => {
                    return {
                      ...prevState,
                      datosGenerales: {
                        ...formValues,
                        CantidadPack: e.target.value
                      }
                    };
                  })
                  }
                  size="small"
                  type="number"
                  InputProps={{ inputProps: { min: 0 } }}
                  value={formValues.CantidadPack}
                  variant="outlined" />
                
                            </div>
                        </Grid>
                        <Grid size={{ xs: 4, sm: 4, md: 4, lg: 2.2 }}>
                            <div className='insumos-tab-datosGenerales-linea-control'>
                                <span className='span-row'>Pack fraccionable</span>
                                <SwitchInput
                  onChange={handleToggle}
                  name='fraccionable'
                  checked={formValues.Fraccionable} />
                
                            </div>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                            <div className='insumos-tab-datosGenerales-linea-control'>
                                <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                                    <TextField
                    label="Motivo de rechazo"
                    name="MotivoValidacion"
                    size="small"
                    type="text"
                    value={formValues.MotivoValidacion}
                    variant="outlined"
                    disabled="true" />
                  

                                </FormControl>
                            </div>
                        </Grid>
                        <Grid
              container
              direction="row"
              justifyContent="space-between"
              spacing={2}>
              
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className='insumos-tab-datosGenerales-linea-control'>
                                    <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                                        <TextField
                      label="Proteinas"
                      name="Proteinas"
                      onChange={formHandle}
                      onBlur={(e) =>
                      setInsumo((prevState) => {
                        return {
                          ...prevState,
                          datosGenerales: {
                            ...formValues,
                            Proteinas: e.target.value
                          }
                        };
                      })
                      }
                      size="small"
                      type="number"
                      value={formValues.Proteinas}
                      disabled={formValues.IdTipoInsumo != 1}
                      variant="outlined" />
                    

                                    </FormControl>
                                </div>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className='insumos-tab-datosGenerales-linea-control'>
                                    <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                                        <TextField
                      label="Calorias"
                      name="Calorias"
                      onChange={formHandle}
                      onBlur={(e) =>
                      setInsumo((prevState) => {
                        return {
                          ...prevState,
                          datosGenerales: {
                            ...formValues,
                            Calorias: e.target.value
                          }
                        };
                      })
                      }
                      size="small"
                      type="number"
                      value={formValues.Calorias}
                      disabled={formValues.IdTipoInsumo != 1}
                      variant="outlined" />
                    

                                    </FormControl>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </div>

            <CustomDialog
        maxWidth="lg"
        fullWidth={true}
        open={openDlgSAP}
        title={'Búsqueda de Articulos SAP'}
        onCancel={handleCloseDlgSAP}
        cancelText='Cerrar'>
        
                <Stack direction="row" spacing={1} alignItems="center">
                    <FormControl sx={{ backgroundColor: 'white', width: 300 }} size="small">
                        <TextField
              label="Filtrar"
              name="txtFiltro"
              size="small"
              type="text"
              variant="outlined"
              inputRef={txtFiltro}
              onKeyUp={handleSearch}
              sx={{ backgroundColor: 'white' }}
              InputProps={{
                endAdornment:
                <InputAdornment position="end">
                                        <SearchIcon
                    onClick={handleSearch}
                    sx={{ cursor: 'pointer' }} />
                  
                                        <ClearIcon
                    onClick={handleClean}
                    sx={{ cursor: 'pointer' }} />
                  
                                    </InputAdornment>

              }} />
            
                    </FormControl>
                </Stack>
                <br />
                <DataGridGenerico
          columns={columns}
          rows={productosSAP}
          toolbar={false}
          onRowClick={handleRowClick}
          totalCount={productosSAP.length} />
        
            </CustomDialog>
        </>);

}